import React, { createContext, useContext, ReactNode } from 'react';

interface DashboardContextType {
  refreshDashboard: () => void;
}

const DashboardContext = createContext<DashboardContextType | undefined>(undefined);

export const useDashboard = () => {
  const context = useContext(DashboardContext);
  if (context === undefined) {
    throw new Error('useDashboard must be used within a DashboardProvider');
  }
  return context;
};

interface DashboardProviderProps {
  children: ReactNode;
  refreshDashboard: () => void;
}

export const DashboardProvider: React.FC<DashboardProviderProps> = ({ children, refreshDashboard }) => {
  return (
    <DashboardContext.Provider value={{ refreshDashboard }}>
      {children}
    </DashboardContext.Provider>
  );
};
